import {handicaddieAsyncThunk} from "../../asyncThunk";
import {ClubService, GetClubsResponse} from "../../../api/ClubService";
import {SessionState} from "../session/slice";
import {PrepaidBagProductService, PrepaidBagProductsResponse} from "../../../api/PrepaidBagProductService";
import {CaddieService} from "../../../api/CaddieService";

export const loadClubs = handicaddieAsyncThunk(
    "Clubs/loadClubs",
    async (_, thunkAPI) => {
        let state = thunkAPI.getState();

        if (state.session.sessionState !== SessionState.ACTIVE) {
             return {}
        }

        let userId = state.session.user?.id
        if ((state.clubs.allClubs && state.clubs.allClubs.length > 0) || !userId) {
            thunkAPI.abort()
            return {}
        }

        let caddiesForUser = await CaddieService().getCaddiesForUser(userId)
        let allClubs: GetClubsResponse = await ClubService().getClubs()

        return {
            clubs: allClubs.clubs?.filter(club => caddiesForUser.caddies?.filter(c => c.approved).map(c => c.clubId).includes(club.id))
        }
    }
);


export const loadPrepaidBagProducts = handicaddieAsyncThunk(
    "Clubs/loadPrepaidBagProducts",
    async (_, thunkAPI) => {
        let state = thunkAPI.getState();

        if (!state.clubs.selected.club) {
             return {}
        }

        let club = state.clubs.selected.club

        if (!club.hasPrepaidBags) {
            return {}
        }

        let resp: PrepaidBagProductsResponse = await PrepaidBagProductService().getAllPrepaidBagProductsForClub(club.id)

        return {
            products: resp.products
        }
    }
);

